import $api from '@/http/api'
import $common from '../common'

export default {
	namespaced: true,
	state: {
		state: {
			patientEducationStatus: false,
			popularStatus: false
		},
		tabActive: 1,
		remindActive: 0,
		serviceChild: {} // 正在进行预约操作的服务项信息
	},
	getters: {
		getInformationState: state => state.state,
		tabActive: state => $common.storeGetterSessionCommon(state, 'tabActive', 'number'),
		remindActive: state => $common.storeGetterSessionCommon(state, 'remindActive', 'number')
	},
	mutations: {
		['SET_INFORMATION_STATE'](state, val) {
			state.state = val
		},
		['SET_INFORMATION_TABACTIVE'](state, val) {
			state.tabActive = val
		},
		['SET_INFORMATION_REMINDACTIVE'](state, val) {
			state.remindActive = val
		}
	},
	actions: {
		/**
		 * @method 获取详情
		 * @params { string } id 服务id
		 * @params { cb } 回调方法
		 */
		async apiGetInformationStatus({ commit }, { params }) {
			const { code, data } = await $api.information.getUnreadNum({
				patientId: params
			})
			if (!code) {
				commit('SET_INFORMATION_STATE', data)
			}
		}
	}
}
